export default "https://platform-api.carrotenglish.net"
